import React, { useEffect, useState } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import {
  Button,
  Fade,
  Grid,
  Skeleton,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import theme from "../../theme/theme";
// import { is } from "date-fns/locale";
import { Link as RouterLink, useLocation } from "react-router-dom";
import ImageBGSection from "./ImageBGSection";

const ConsultancyTabs = ({ tabs, loading }) => {
  const [value, setValue] = useState("0");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById("tabs");
      if (element) {
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
        setIsVisible(isVisible);
      }
    };

    window.addEventListener("scroll, load", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll, load", handleScroll);
      setIsVisible(false);
      setValue("0");
    };
  }, [location.pathname]); // run only when location.pathname changes

  if (loading) {
    return (
      <Skeleton
        animation="wave"
        type="rectangle"
        height={"360px"}
        sx={{
          m: 0,
        }}
      />
    );
  }

  // if (!tabs) {
  //     return null;
  // }

  if (!tabs.tabs || !Array.isArray(tabs.tabs)) {
    return null; // Ou renderize um fallback apropriado
  }

  const isSingleTab = tabs.tabs.length === 1;
  const tabContent = tabs.tabs[0];

  return (
    <Fade in={true} timeout={250}>
      <Box
        sx={{
          padding: "50px 5% 60px 5%",
          //   backgroundImage: `url(${tabs.background_image.link})`,
          backgroundColor: "#F0F0F0",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        id="tabs"
      >
        <Fade in={true} timeout={1500}>
          <Typography
            sx={{
              fontSize: "1.5rem",
              fontWeight: "800",
              color: "#265DA5",
              textAlign: "center",
              width: "100%",
              marginBottom: "20px",
            }}
          >
            {tabs.tabs_title}
          </Typography>
        </Fade>
        <Fade in={true} timeout={2000}>
          <Typography
            sx={{
              fontSize: "1.2rem",
              textAlign: "center",
              width: "100%",
              marginBottom: "40px",
            }}
          >
            {tabs.tabs_intro}
          </Typography>
        </Fade>

        <TabContext value={value}>
          <Grid
            container
            sx={{
              background: "rgba(255, 255, 255, 0.7)",
              maxWidth: `${!isSingleTab ? theme.width.maxwidth : "950px"}`,
              margin: "0 auto",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            }}
          >
            {!isSingleTab && (
              <Grid item md={4} xs={12}>
                <Tabs
                  defaultValue="0"
                  orientation="vertical"
                  value={value}
                  onChange={handleChange}
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: tabs.tab_colour,
                      right: "unset",
                      left: "0",
                      width: "8px",
                    },
                  }}
                >
                  {tabs.tabs.map((tab, index) => (
                    <Tab
                      label={tab.topic}
                      value={index.toString()}
                      key={index}
                      sx={{
                        textAlign: "left",
                        alignItems: "flex-start",
                        color: "#292929",
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: "1rem",
                        maxWidth: "100%",
                        padding: "12px 30px",
                        minHeight: "60px",
                        "&.Mui-selected": {
                          backgroundColor: "rgba(255, 255, 255, 0.7)",
                          color: "#292929",
                        },
                      }}
                    />
                  ))}
                </Tabs>
              </Grid>
            )}
            <Grid item md={isSingleTab ? 12 : 8} xs={12}>
              {tabs.tabs.map((tab, index) => (
                <TabPanel
                  value={index.toString()}
                  index={index.toString()}
                  key={index}
                  sx={{
                    padding: "20px 44px 24px 46px",
                    background: "rgba(255, 255, 255, 0.7)",
                    // minHeight: '100%',
                    // minHeight: isSingleTab ? 'unset' : '500px',
                  }}
                >
                  {/* <Box dangerouslySetInnerHTML={{ __html: tab.content }} /> */}
                  {/* {tab.link_text && (
                    <Button
                      sx={{
                        color: "#ffffff",
                        backgroundColor: "#265DA5",
                        fontSize: "1rem",
                        borderRadius: "50px",
                        fontWeight: "600",
                        padding: "0.5rem 1rem",
                        marginTop: "30px",
                        marginBottom: "25px",
                        "&:hover": {
                          backgroundColor: "#E9531C",
                        },
                      }}
                      component={RouterLink}
                      to={tab.link_url}
                    >
                      {tab.link_text}
                    </Button>
                  )}
                  {tab.image && (
                    <Box
                      component="img"
                      src={tab.image}
                      alt={tab.topic}
                      sx={{
                        width: "100%",
                        height: "auto",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  )} */}
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={8}>
                      <Box dangerouslySetInnerHTML={{ __html: tab.content }} />
                    </Grid>
                    {tab.image && (
                      <Grid
                        item
                        xs={12}
                        md={4}
                        display="flex"
                        justifyContent="center"
                      >
                        <Box
                          component="img"
                          src={tab.image}
                          alt={tab.topic}
                          sx={{
                            maxWidth: "350px",
                            height: "auto",
                          }}
                        />
                      </Grid>
                    )}

                    {tab.link_text && (
                      <Grid item xs={12} display="flex" justifyContent="center">
                        <Button
                          sx={{
                            color: "#ffffff",
                            backgroundColor: "#265DA5",
                            fontSize: "1rem",
                            borderRadius: "50px",
                            fontWeight: "600",
                            padding: "0.5rem 1rem",
                            marginTop: "20px",
                            marginBottom: "20px",
                            "&:hover": {
                              backgroundColor: "#E9531C",
                            },
                          }}
                          component={RouterLink}
                          to={tab.link_url}
                        >
                          {tab.link_text}
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </TabPanel>
              ))}
            </Grid>
          </Grid>
        </TabContext>
      </Box>
    </Fade>
  );
};

export default ConsultancyTabs;
